export const colors = {
  primary: '#7180AC',
  secondary: '#2B4570',
  accent: '#FFC857',
};
